import { Box, Typography, useTheme } from '@mui/material';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { AnnotatorAnnotationsTab } from './AnnotatorTab/AnnotatorAnnotationsTab';
import { ConflictTab } from './ConflictTab/ConflictTab';
import { ResolvedTab } from './ResolvedTab/ResolvedTab';
import { SUPERVISOR_REVIEW_TAB_OPTIONS } from '../../../constants';
import { selectReviewTabSelected } from '../../../state/selector';

export const SupervisorSelectedTab = () => {
  const selectedReviewTab = useAppSelector(selectReviewTabSelected);
  return (
    <Box>
      {selectedReviewTab === SUPERVISOR_REVIEW_TAB_OPTIONS[0] ? (
        <Box>
          <AnnotatorAnnotationsTab />
        </Box>
      ) : selectedReviewTab === SUPERVISOR_REVIEW_TAB_OPTIONS[1] ? (
        <Box>
          <AnnotatorAnnotationsTab />
        </Box>
      ) : selectedReviewTab === SUPERVISOR_REVIEW_TAB_OPTIONS[2] ? (
        <Box>
          <ConflictTab />
        </Box>
      ) : selectedReviewTab === SUPERVISOR_REVIEW_TAB_OPTIONS[3] ? (
        <Box>
          <ResolvedTab />
        </Box>
      ) : (
        <Box>
          <Typography variant="h6">Selected Tab</Typography>
        </Box>
      )}
    </Box>
  );
};
